export enum DocumentType {
  Passport = 0,
  Id = 1,
  DrivingLicense = 2,
  Government = 3,
  UtilityBill = 4,
  NationalInsurance = 5,
  BankStatement = 6
}
